import { useRouteError } from 'react-router-dom';

const ErrorBoundary = () => {
  const error = useRouteError();

  if (error) throw error;

  return null;
};

export default ErrorBoundary;
